﻿import { getCookie } from '../functions.js';

const loginStateApp = {
    data() {
        return {
            homeLoggedInUrl: ''
        }
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isAuthenticated
        }
    },
    mounted() {
        if (this.$el.parentNode.dataset.homeloggedin) this.homeLoggedInUrl = this.$el.parentNode.dataset.homeloggedin;
    }
}

export default loginStateApp;